import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function usersLoader() {
    const users = await queryClient.fetchQuery({
        queryKey: ['users'],
        queryFn: async () => {
            const { data } = await api.user.findAll();
            return data;
        },
    });
    return users;
}

export async function adminUsersLoader() {
    const users = await queryClient.fetchQuery({
        queryKey: ['adminUsers'],
        queryFn: async () => {
            const { data } = await api.user.findAdminUsers();
            return data;
        },
    });
    return users;
}

export async function adminUserLoader({ params }: LoaderFunctionArgs) {
    const userId = params.userId!;

    const users = await queryClient.fetchQuery({
        queryKey: ['adminUsers', userId],
        queryFn: async () => {
            const { data } = await api.user.findAdminUser(userId);
            return data;
        },
    });
    return users;
}

export async function userLoader({ params }: LoaderFunctionArgs) {
    const userId = params.userId;
    const companiesPromise = queryClient.fetchQuery({
        queryKey: ['companies'],
        queryFn: async () => {
            const { data } = await api.company.findAll();
            return data;
        },
    });

    const rolesPromise = queryClient.fetchQuery({
        queryKey: ['roles'],
        queryFn: async () => {
            const { data } = await api.role.findAll();
            return data;
        },
    });

    const userPromise = userId
        ? queryClient.fetchQuery({
              queryKey: ['user', userId],
              queryFn: async () => {
                  const { data } = await api.user.find(userId);
                  return data;
              },
          })
        : undefined;

    const [companies, roles, user] = await Promise.all([companiesPromise, rolesPromise, userPromise]);

    return { companies, roles, user };
}
